<template>
  <div id="app">
    <div id="customecontainer">
      <b-row>
        <b-col id="left" class="hidesmaller" col cols="0" sm="0" md ="0" lg="3" xl="2">
          <Navbar/>
        </b-col>
        <b-col id="center" cols="12" sm="8" md="9" lg="7" xl="7" offset-lg="3" offset-xl="2">
          <AboutMe id="about"/>
          <WhatIHaveDone id="resume"/>
        </b-col>
        <b-col id="right" col cols="0" sm="4" md="3" lg="2" xl="3">
          <Link/>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
import AboutMe from "./components/About";
import WhatIHaveDone from "./components/WhatIHaveDone";
import Link from "./components/Links";

export default {
  name: "app",
  components: {
    Navbar,
    AboutMe,
    WhatIHaveDone,
    Link
  }
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  background-color: #f9f9f9;
}
#customecontainer{
  display: flex;
  flex: 0 1 1200px;
  flex-wrap: wrap;
  padding: 50px;
}
#center {
  flex: 1;
}
#left{
  position: fixed;
}
@media all and (max-width: 576px) and (min-width: 0px) {
  #left{
    display: none;
  }
  
  #right{
    display: none;
  }
  
  #center{
    padding: 0;
  }
}

@media all and (max-width: 991px) and (min-width: 577px) {
  #left{
    display: none;
  }

  #center{
    padding: 0;
  }
}

@media all and (min-width: 1200px){
  #center{
    padding-left: 40px;
  }
}
</style>
